import type {TCardsInHand} from '@kapitalist/contract/types'
import {cardFactory} from '~/models/game/factories'
import Hand from '~/models/game/Hand'
import type {AnyCard} from '~/models/game/types'

export default class ExposedHand extends Hand {
  public cards: AnyCard[]

  constructor(handData: TCardsInHand & {type: 'exposed'}) {
    super()
    this.cards = handData.cards.map(c => cardFactory(c))
  }

  public cardCount(): number {
    return this.cards.length
  }
}
